import { render } from "./custom-domain.vue?vue&type=template&id=5bbacf76&scoped=true"
import script from "./custom-domain.vue?vue&type=script&lang=js"
export * from "./custom-domain.vue?vue&type=script&lang=js"

import "./custom-domain.vue?vue&type=style&index=0&id=5bbacf76&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbacf76"]])

export default __exports__